import { ORGANIZATION_SCOPE_PREFIX, orgPath, routes } from 'constants/routes';

/** 組織切り替え後の遷移先。`path` は対象組織のスコープ内（`/o/{id}/...`）のときだけ使う。 */
export function resolveSwitchTargetPath(
  targetOrganizationId: number,
  path?: string,
): string {
  const fallback = orgPath(targetOrganizationId, routes.LINE);
  if (!path) return fallback;
  return path.startsWith(`${ORGANIZATION_SCOPE_PREFIX}/${targetOrganizationId}/`)
    ? path
    : fallback;
}
